import CollaborativeEditing from '@/constant/CollaborativeEditing'
import Events from '@/constant/Events'
import IdeasTabName from '@/constant/IdeasTabName'
import QuizStatuses from '@/constant/QuizStatuses'
import SpinnerWheelConfig from '@/constant/SpinnerWheelConfig'
import errors from '@/constant/errors'
import eventCategories from '@/constant/eventCategories'
import identityProviders from '@/constant/identityProviders'
import invitationStatus from '@/constant/invitationStatus'
import permissions from '@/constant/permissions'
import role from '@/constant/role'
import storageKeys from '@/constant/storageKeys'
import workspace from '@/constant/workspace'
import AIResponseType from '@/constant/aiResponseType'
import presenterLanguage from '@/constant/locale'
import CrazyEggSurveyNames from '@/constant/CrazyEggSurveyNames'
import { slideTypes } from '@/constant/slideTypes'
import routes from '@/constant/routes'
import noAudio from '@/constant/noAudio'
import importStatus from '@/constant/importStatus'
import openAI from '@/constant/openAI'
import aiAction from '@/constant/aiAction'

// Onboarding slide 2 images
const educationForm = require('@/assets/images/onboarding/slide2-education-form.svg')
const workForm = require('@/assets/images/onboarding/slide2-work-form.svg')
const communityForm = require('@/assets/images/onboarding/slide2-community-form.svg')

// Onboarding v3 images
const createOptionImage = require('@/assets/images/onboarding/blank.svg')
const uploadOptionImage = require('@/assets/images/onboarding/upload-ppt.svg')
const templatesOptionImage = require('@/assets/images/onboarding/explore-templates.svg')

const classEn = require('@/assets/images/onboarding/class.svg')
const joyful = require('@/assets/images/onboarding/joyful.svg')
const joyfulgatherings = require('@/assets/images/onboarding/joyfulgatherings.svg')
const leaving = require('@/assets/images/onboarding/leaving.svg')
const meaningful = require('@/assets/images/onboarding/meaningful.svg')
const real = require('@/assets/images/onboarding/real.svg')
const remote = require('@/assets/images/onboarding/remote.svg')
const teambuilding = require('@/assets/images/onboarding/teambuilding.svg')
const total = require('@/assets/images/onboarding/total.svg')
const training = require('@/assets/images/onboarding/training.svg')

// Onboarding slide 1 images
const educationOptionImage = require('@/assets/images/onboarding/eduv2.svg')
const workOptionImage = require('@/assets/images/onboarding/slide1-work.svg')
const communityOptionImage = require('@/assets/images/onboarding/slide1-community.svg')
const othersOptionImage = require('@/assets/images/onboarding/slide1-others.svg')

// Onboarding v4 images
const createNewImage = require('@/assets/images/onboarding/v4/create-new.svg')
const uploadImage = require('@/assets/images/onboarding/v4/upload.svg')
const templatesImage = require('@/assets/images/onboarding/v4/templates.png')

// Onboarding v4 video
const templatesVideo = require('@/assets/images/onboarding/v4/templates.webm')

const euRegion = 'eu'
const globalRegion = 'gb'
const MASONRY_TRANSITION_DURATION = 300 // 300ms
const MIN_VOTE_IDEAS = 1
const MAX_VOTE_IDEAS = 20
const MAX_IDEAS_NUMBER = 200
const MAX_CORRECT_ORDER_OPTIONS = 7
const defaultQuestionTitle = 'Click to add question'
const defaultHeadingTitle = 'Click to add heading'

const AB_TEST = {
  SHARE_V2: 'SHARE_V2',
  SLIDE_TYPE_PREVIEW: 'SLIDE_TYPE_PREVIEW',
  PLAN_UPGRADE_EDITOR: 'PLAN_UPGRADE_EDITOR',
}

const AB_VARIANT = {
  CONTROL: 'CONTROL',
  TREATMENT: 'TREATMENT',
}

const DEFAULT_IMAGE_RATIOS = {
  QUESTION_IMAGE: 4 / 3,
  SLIDE_OPTION_IMAGE: 1,
  BACKGROUND_IMAGE: 16 / 9,
  LOGO: 4.45,
}

const SLIDE_TYPE = {
  PICK_ANSWER: 'pickAnswer',
  PICK_IMAGE: 'imageChoice',
  MULTIPLE_CHOICE: 'multipleChoice',
  FREESTYLE: 'freestyle',
  WORD_CLOUD: 'wordCloud',
  OPEN_ENDED: 'openEnded',
  IDEAS: 'ideas',
  QUESTION: 'question',
  SCALE: 'scale',
  SPINNER_WHEEL: 'spinnerWheel',
  QRCODE: 'qrcode',
  TEXT_SLIDE: 'textSlide',
  BULLET_POINTS: 'bulletPoints',
  IMAGE: 'image',
  LEADERBOARD: 'leaderboard',
  CORRECT_ORDER: 'correctOrder',
  MATCH_PAIRS: 'matchPairs',
  IMAGE_CHOICE: 'imageChoice',
  TYPE_ANSWER: 'typeAnswer',
  POLL: 'poll',
  CATEGORISE: 'categorise',
}

const INDIVIDUAL_REPORT_QUESTION_TYPE = {
  WORD_CLOUD: 'Word Cloud',
  OPEN_ENDED: 'Open Ended',
  BRAIN_STORM: 'Brainstorm',
}

const SLIDE_NAMES = {
  [SLIDE_TYPE.PICK_ANSWER]: 'Pick Answer',
  [SLIDE_TYPE.CORRECT_ORDER]: 'Correct Order',
  [SLIDE_TYPE.MATCH_PAIRS]: 'Match Pairs',
  [SLIDE_TYPE.TYPE_ANSWER]: 'Short Answer',
  [SLIDE_TYPE.IMAGE_CHOICE]: 'Pick Answer',
  [SLIDE_TYPE.IDEAS]: 'Brainstorm',
  [SLIDE_TYPE.WORD_CLOUD]: 'Word Cloud',
  [SLIDE_TYPE.OPEN_ENDED]: 'Open Ended',
  [SLIDE_TYPE.SCALE]: 'Rating Scale',
  [SLIDE_TYPE.POLL]: 'Poll',
  [SLIDE_TYPE.CATEGORISE]: 'Categorise',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.WORD_CLOUD]: INDIVIDUAL_REPORT_QUESTION_TYPE.WORD_CLOUD,
  [INDIVIDUAL_REPORT_QUESTION_TYPE.OPEN_ENDED]: INDIVIDUAL_REPORT_QUESTION_TYPE.OPEN_ENDED,
  [INDIVIDUAL_REPORT_QUESTION_TYPE.BRAIN_STORM]: INDIVIDUAL_REPORT_QUESTION_TYPE.BRAIN_STORM,
}
export default {
  routes,
  presenterLanguage,
  globalRegion,
  euRegion,
  eventCategories,
  identityProviders,
  errors,
  storageKeys,
  invitationStatus,
  QuizStatuses,
  CollaborativeEditing,
  IdeasTabName,
  Events,
  workspace,
  AIResponseType,
  CrazyEggSurveyNames,
  importStatus,
  openAI,
  aiAction,
  permissions,
  role,
  MASONRY_TRANSITION_DURATION,
  MIN_VOTE_IDEAS,
  MAX_VOTE_IDEAS,
  MAX_IDEAS_NUMBER,
  MAX_CORRECT_ORDER_OPTIONS,
  allTypeSections: slideTypes,
  chartTypes: {
    bars: {
      name: 'Bars',
      icon: 'far fa-chart-bar',
      type: 'barChart',
    },
    donut: {
      name: 'Donut',
      icon: 'fas fa-chart-pie',
      type: 'donutChart',
    },
    pie: {
      name: 'Pie',
      icon: 'fas fa-chart-pie',
      type: 'pieChart',
    },
  },
  pricesMap: {
    vnd: {
      'essential-yearly': 2400000,
      'plus-yearly': 3300000,
      'pro-yearly': 4800000,
      'ultimate-daily': 0.04,
    },
    sgd: {
      'essential-yearly': 129,
      'plus-yearly': 177,
      'pro-yearly': 261,
    },
    eur: {
      'essential-yearly': 87,
      'plus-yearly': 123,
      'pro-yearly': 183,
      'ultimate-daily': 0.04,
    },
    usd: {
      'essential-yearly': 95.4,
      'plus-yearly': 131.4,
      'pro-yearly': 191.4,
      'ultimate-daily': 0.04,
    },
  },

  BulkLicensePlans: {
    'essential-yearly': 'Essential Yearly',
    'plus-yearly': 'Plus Yearly',
    'pro-yearly': 'Pro Yearly',
    enterprise: 'Enterprise',
    whitelabel: 'White Label',
  },
  BulkLicensePlansPricingV3: {
    'essential-yearly': 'Essential Yearly',
    'pro-yearly': 'Pro Yearly',
    enterprise: 'Enterprise',
    whitelabel: 'White Label',
  },
  BulkLicensePlansPricingV4: {
    'essential-yearly': 'Essential Yearly',
    'pro-yearly': 'Pro Yearly',
  },

  openEndedLayout: {
    grid: {
      name: 'Grid',
      icon: 'fas fa-th',
      type: 'grid',
    },
    oneByOne: {
      name: 'One by one',
      icon: 'far fa-sticky-note',
      type: 'oneByOne',
    },
  },
  additionalFields: {
    name: {
      name: 'name',
      type: 'name',
      label: 'Enter your name:',
      required: false,
      id: 1,
    },
    team: {
      name: 'team',
      type: 'team',
      label: 'Enter your organisation:',
      required: false,
      id: 2,
    },
    email: {
      name: 'email',
      type: 'email',
      label: 'Enter your email address:',
      required: false,
      id: 4,
    },
    avatar: {
      name: 'avatar',
      type: 'avatar',
      label: 'Choose an emoji as your avatar:',
      required: false,
      id: 3,
    },
  },
  audienceAdmissionFields: {
    name: {
      name: 'name',
      type: 'name',
      label: 'Enter your name:',
      required: false,
      id: 1,
      textLimit: 20,
    },
    team: {
      name: 'team',
      type: 'team',
      label: 'Enter your organisation:',
      required: false,
      id: 2,
      textLimit: 20,
    },
    email: {
      name: 'email',
      type: 'email',
      label: 'Enter your email address:',
      required: false,
      id: 3,
      textLimit: 60,
    },
  },
  legacyColors: [
    // https://trello.com/c/383hc2zf/430-%C4%91%E1%BB%95i-list-m%C3%A0u-d%C3%B9ng-cho-c%C3%A1c-chart
    'rgba(78, 170, 241, 1)', // blue
    'rgba(255, 175, 9, 1)', // yel
    'rgba(40, 194, 112, 1)', // green
    'rgba(253, 93, 161, 1)', // pink
    'rgba(118, 105, 191, 1)', // purple
    'rgba(18, 67, 69, 1)', // dark teal
    'rgba(156, 162, 174, 1)', // grey
    'rgba(79, 151, 241, 1)', // blue 2
    'rgba(255, 199, 0, 1)', // yel 2
    'rgba(40, 194, 129, 1)', // green 2
    'rgba(253, 93, 142, 1)', // pink 2
    'rgba(127, 105, 191, 1)', // purple 2
    'rgba(37, 43, 53, 1)', // near black
    'rgba(156, 165, 174, 1)', // grey 2
    'rgba(77, 183, 240, 1)', // blue 3
    'rgba(255, 156, 16, 1)', // orange
    'rgba(40, 194, 99, 1)', // green 3
    'rgba(253, 92, 173, 1)', // pink 3
    'rgba(110, 105, 191, 1)', // purple 3
    'rgba(59, 30, 54, 1)', // dark plum
    'rgba(162, 155, 175, 1)', // grey purple
    'rgba(116, 76, 242, 1)', // purple 4
    'rgba(154, 240, 37, 1)', // neon green
    'rgba(43, 158, 195, 1)', // sky
    'rgba(253, 152, 89, 1)', // light orange
    'rgba(182, 105, 191, 1)', // weird purple
    'rgba(55, 52, 33, 1)', // some brown-green
    'rgba(155, 170, 174, 1)', // grey blue
    'rgba(74, 225, 239, 1)', // fresh blue
    'rgba(255, 100, 28, 1)', // fresh orange
  ],
  colors: [
    '#6A1EBB',
    '#20E8B5',
    '#FF4081',
    '#FF9068',
    '#B4E4E0',
    '#5A189A',
    '#D3B4FF',
    '#E6005C',
    '#FAF0F6',
    '#3E3E5A',
    '#5A189A',
    '#6A1EBB',
    '#20E8B5',
    '#FF4081',
    '#FF9068',
    '#B4E4E0',
    '#D3B4FF',
    '#E6005C',
    '#FAF0F6',
    '#3E3E5A',
  ],
  colorsHex: ['4EAAF1', '#FFAF09', '#28C270', '#FF5DA1', '#7669BF', '#124345'],
  chartDefaultData: {
    labels: ['Option 1', 'Option 2', 'Option 3'],
    values: [1, 1, 1],
    limit: 2,
  },
  defaultBaseColour: [
    {
      color: '#ffffff',
      textColour: '#313131',
    },
    {
      color: '#c9e6fd',
      textColour: '#313131',
    },
    {
      color: '#fff4da',
      textColour: '#313131',
    },
    {
      color: '#ffebf8',
      textColour: '#313131',
    },
    {
      color: '#222222',
      textColour: '#ffffff',
    },
    {
      color: '#212a4c',
      textColour: '#ffffff',
    },
    {
      color: '#541330',
      textColour: '#ffffff',
    },
  ],
  legacyLighterColors: [
    '#c7e2f4',
    '#fce4b6',
    '#bee9cd',
    '#fbcadc',
    '#d3cfe5', // purple 1st
    '#b6c3c1',
    '#dedfe0', // 1st gray
    '#c7dcf4',
    '#fcebb6', // 2nd yellow
    '#bee9d3',
    '#fbcbd7', // 2nd pink
    '#d5cfe5', // 2nd purple
    '#bbbcbc',
    '#dee0e0', // 2nd gray
    '#c7e6f4', // 3rd blue
    '#fcddb7',
    '#bee9ca',
    '#fbcae0', // 3rd pink
    '#d1cfe5', // 3rd purple
    '#c1b8bc',
    '#e0dde0',
    '#d2c7f4',
    '#ddf7bb', // yellow green
    '#bedee7',
    '#fbdcc8',
    '#e6cee5', // last purple
    '#c0beb6',
    '#dee1e0',
    '#c7f2f3',
    '#fccdb7',
  ],
  lighterColors: [
    '#9D5EE5',
    '#79F3D0',
    '#FF7DAA',
    '#FFB89A',
    '#DFF4F2',
    '#8D51DC',
    '#EBD6FF',
    '#FF5D95',
    '#FFFFFF',
    '#6F6F89',
    '#8D51DC',
    '#9D5EE5',
    '#79F3D0',
    '#FF7DAA',
    '#FFB89A',
    '#DFF4F2',
    '#EBD6FF',
    '#FF5D95',
    '#FFFFFF',
    '#6F6F89',
  ],
  fonts: {
    plusjakartasans: {
      value: "'Plus Jakarta Sans', sans-serif",
      name: 'plusjakartasans',
      label: 'Plus Jakarta Sans',
    },
    nunito: {
      value: '',
      name: 'nunito',
      label: 'Nunito',
    },
    roboto: {
      url: 'https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Roboto', sans-serif",
      name: 'roboto',
      label: 'Roboto',
    },
    opensan: {
      url: 'https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Open Sans', sans-serif",
      name: 'opensan',
      label: 'Open Sans',
    },
    oswald: {
      url: 'https://fonts.googleapis.com/css?family=Oswald:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Oswald', sans-serif",
      name: 'oswald',
      label: 'Oswald',
    },
    montserrat: {
      url: 'https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Montserrat', sans-serif",
      name: 'montserrat',
      label: 'Montserrat',
    },
    sourceCodePro: {
      url: 'https://fonts.googleapis.com/css?family=Source+Code+Pro:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Source Code Pro', 'Courier New', Courier, monospace",
      name: 'sourceCodePro',
      label: 'Source Code Pro',
    },
    merriweather: {
      url: 'https://fonts.googleapis.com/css?family=Merriweather:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Merriweather', serif",
      name: 'merriweather',
      label: 'Merriweather',
    },
    ebGaramond: {
      url: 'https://fonts.googleapis.com/css?family=EB+Garamond:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'EB Garamond', serif",
      name: 'ebGaramond',
      label: 'EB Garamond',
    },
    robotoSlab: {
      url: 'https://fonts.googleapis.com/css?family=Roboto+Slab:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Roboto Slab', serif",
      name: 'robotoSlab',
      label: 'Roboto Slab',
    },
    cairo: {
      url: 'https://fonts.googleapis.com/css?family=Cairo:400,700&display=swap&subset=arabic',
      value: "'Cairo', sans-serif",
      name: 'cairo',
      label: 'Cairo',
    },
    kanit: {
      url: 'https://fonts.googleapis.com/css?family=Kanit:400,700&display=swap&subset=thai',
      value: "'Kanit', sans-serif",
      name: 'kanit',
      label: 'Kanit',
    },
  },
  defaultQuizTeam: {
    teamCount: 5,
    teamSize: 3,
  },
  commonSlideAttributes: [
    // Background settings
    'textColour', 'visibility', 'baseColour',
    'backgroundImage', 'originBackgroundImage', 'backgroundImageCropperData',
    // Audio settings
    'audioShowControl', 'audioAutoPlay', 'audioRepeat',
    'audioPlayOnAudience', 'audioAudienceShowControl', 'audioAudienceAutoPlay',
    'audioAudienceRepeat', 'audioLink', 'audioName',
    // Type
    'type',
    // local background image cache related fields
    'backgroundCache', 'cropperDataCache', 'originBackgroundCache', 'backgroundCacheExtension',
  ],
  slidesRequiringImageButton: [SLIDE_TYPE.SCALE, SLIDE_TYPE.MULTIPLE_CHOICE, SLIDE_TYPE.OPEN_ENDED,
    SLIDE_TYPE.WORD_CLOUD, SLIDE_TYPE.PICK_ANSWER, SLIDE_TYPE.IMAGE_CHOICE,
    SLIDE_TYPE.QUESTION, SLIDE_TYPE.IDEAS],
  onboardingOptions: [
    {
      name: 'Work',
      useAhaSlidesFor: 'work',
      contentHeading: 'Make your workplace brighter…',
      formImage: workForm,
      optionImage: workOptionImage,
      customClass: 'work',
      benefits: [
        {
          heading: ' Productive meetings',
          content: 'Organise team thoughts with structured polls, ratings, brainstorms and Q&As.',
          image: meaningful,
        },
        {
          heading: 'Team building',
          content: 'Host fun team hangouts full of quizzes, engaging questions and games.',
          image: teambuilding,
        },
        {
          heading: 'Training and workshops',
          content: 'Enliven training with active participation and total attention.',
          image: training,
        },
      ],
    },
    {
      name: 'School',
      useAhaSlidesFor: 'education',
      contentHeading: 'Your learners are gonna love this…',
      formImage: educationForm,
      optionImage: educationOptionImage,
      benefits: [
        {
          heading: 'Class engagement',
          content: 'Make teaching more engaging with interactive questions, idea exchanges, and more.',
          image: classEn,
        },
        {
          heading: 'Real-time assessments',
          content: 'Create quizzes for learners to do live in-class or at home, and get instant feedback.',
          image: real,
        },
        {
          heading: 'Leaving no one behind',
          content: 'Anyone can ask questions and contribute, even anonymously.',
          image: leaving,
        },
      ],
    },
    {
      name: 'Community & Friends',
      useAhaSlidesFor: 'community',
      contentHeading: 'Bring everyone together, from anywhere…',
      formImage: communityForm,
      optionImage: communityOptionImage,
      customClass: 'community',
      benefits: [
        {
          heading: 'Joyful gatherings',
          content: 'Host a communal quiz or game night that gets people talking.',
          image: joyfulgatherings,
        },
        {
          heading: 'Meaningful talks',
          content: 'Teach and discuss through polls, idea exchanges, surveys, and more.',
          image: meaningful,
        },
        {
          heading: 'Remote connections',
          content: 'Include everyone in what you do, no matter where they are.',
          image: remote,
        },
      ],
    },
    {
      name: 'Others',
      useAhaSlidesFor: 'others',
      contentHeading: 'Find what you’re looking for…',
      formImage: educationForm,
      optionImage: othersOptionImage,
      customClass: 'others',
      benefits: [
        {
          heading: 'Total engagement',
          content: 'Raise active participation in formal or casual events through interactivity.',
          image: total,
        },
        {
          heading: 'Joyful gatherings',
          content: 'Host fun quizzes and games for small or big hangouts.',
          image: joyful,
        },
        {
          heading: 'Remote connections',
          content: 'Include everyone in what you do, no matter where they are.',
          image: remote,
        },
      ],
    },
  ],
  languageOptions: [
    {
      name: 'English',
      language: 'en',
    },
    {
      name: 'Français',
      language: 'fr',
      country: 'France',
    },
    {
      name: 'Español',
      language: 'es',
      country: 'Spain',
    },
    {
      name: 'Italiano',
      language: 'it',
      country: 'Italy',
    },
    {
      name: 'Tiếng Việt',
      language: 'vi',
      country: 'Vietnam',
    },
    {
      name: 'Pусский',
      language: 'ru',
      country: 'Russian Federation',
    },
    {
      name: '中文',
      language: 'zh',
      country: 'China',
    },
    {
      name: '日本語',
      language: 'ja',
      country: 'Japan',
    },
    {
      name: 'Ελληνικά',
      language: 'el',
      country: 'Greece',
    },
  ],
  onboardingv4Options: [
    {
      name: 'Create blank',
      image: createNewImage,
      type: 'create',
    },
    {
      name: 'Templates',
      video: templatesVideo,
      imageMobile: templatesImage,
      type: 'templates',
    },
    {
      name: 'Upload',
      isAI: true,
      image: uploadImage,
      type: 'upload',
    },
  ],
  onboardingv3Options: [
    {
      name: 'Create',
      image: createOptionImage,
      type: 'create',
    },
    {
      name: 'Upload',
      image: uploadOptionImage,
      type: 'upload',
    },
    {
      name: 'Templates',
      image: templatesOptionImage,
      type: 'templates',
    },
  ],
  presentation: {
    defaultPresentationName: 'My new presentation',
  },
  defaultSlideTitles: [
    // leave messy structure here, in case edit content
    {
      type: 'multipleChoice',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'imageChoice',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'pickAnswer',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'openEnded',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'question',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'wordCloud',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'scale',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'spinnerWheel',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'ideas',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'textSlide',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'bulletPoints',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'freestyle',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'image',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'leaderboard',
      defaultTitle: 'Leaderboard',
    },
  ],
  referPublicTemplate: 'public-template',
  buttonScratch: 'scratch',
  SpinnerWheelConfig,
  AB_TEST,
  AB_VARIANT,
  slideTypesNoAudio: noAudio.slideTypes,
  // If Chloe specifically asked to stop sending to GTM, please include your eventName into stoppedSendingToGoogleTagEvents
  stoppedSendingToGoogleTagEvents: [
    'login',
    'purchase',
    'sign_up',
    'Generate quiz from doc > Open import modal',
    'Import document > Generate quiz from this document',
    'Import document > Generate quiz from this document > Hover',
    'AI > Attachment icon > Open import modal',
    'Import document > Begin uploading',
    'Import document > Quiz generation success',
    'Import document > Failure',
    'Add slide to PowerPoint',
    'Add presentation to PowerPoint',
    'AI Quiz Generator > Example',
    'Header > language > Open',
    'Header > language > Select language',
    'Grouping > Group Words',
    'Grouping > Ungroup Words',
  ],
  DEFAULT_IMAGE_RATIOS,
  SLIDE_TYPE,
  SLIDE_NAMES,
  defaultQuestionTitle,
  defaultHeadingTitle,
  INDIVIDUAL_REPORT_QUESTION_TYPE,
}
